const postCompaniesStr = {
  toastr: 'Empresa agregada',
  toastr1: ' fue agregado con éxito',
  toastrError: 'Empresa ya registrada',
  toastrError1: 'Ingrese este CNPJ o Nombre ya registrado'
};

export default postCompaniesStr;
